module.exports = __webpack_public_path__ + "img/info01.9cc203d7.png";